export { ResendEmailComponent as ResendEmail_ModalComponent } from './resend-email/resend-email.component';
